import { Phone, Truck, ShieldCheck } from "lucide-react";
import { PHONE } from "@/lib/api";

export const TopBar = () => {
  return (
    <div className="bg-navy text-white" data-testid="top-announcement-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-4 text-[11px] sm:text-xs">
          <div className="flex items-center justify-center md:justify-start gap-2">
            <Phone className="h-5 w-5 text-gold shrink-0" />
            <span>
              <span className="font-extrabold">{PHONE}</span>
              <span className="hidden sm:inline text-white/70"> &middot; Comandă telefonică în doar câteva minute!</span>
            </span>
          </div>
          <div className="flex items-center justify-center gap-2">
            <Truck className="h-5 w-5 text-gold shrink-0" />
            <span><span className="font-extrabold">TRANSPORT GRATUIT</span><span className="text-white/70"> la orice comandă</span></span>
          </div>
          <div className="flex items-center justify-center md:justify-end gap-2">
            <ShieldCheck className="h-5 w-5 text-gold shrink-0" />
            <span><span className="font-extrabold">LIVRARE RAPIDĂ</span><span className="text-white/70"> în 1-2 zile lucrătoare</span></span>
          </div>
        </div>
      </div>
    </div>
  );
};
